import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-self: flex-end;
`;

export const BottomButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;

  button {
    padding: 0 8px;
    min-width: ${rem(160)};
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: ${rem(32)};

  button {
    margin: 0;
    flex-grow: 1;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: column;
    gap: ${rem(16)};

    button {
      width: 100%;
    }
  }
`;
